module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'buttons-panel/compact-in-column' && templateVars.config ?
				templateVars.config :
				{
	"tools": {
		"title": {
			"ru": "Инструменты",
			"en": "Tools"
		},
		"slideType": "vertical",
		"sublistSlideType": "left",
		"InMyReport": false,
		"includeComponent": "page-nav/vertical",
		"buttonWithText": false,
		"offlineHideButtons": [
			"offline",
			"feedback",
			"share",
			"social"
		],
		"buttonsPanelHideButtons": [
			"siteMap",
			"compare",
			"offline",
			"questionary",
			"social",
			"ios",
			"android",
			"mobileApp",
			"companyOnMap",
			"siteMap",
			"contacts",
			"xls",
			"glossary",
			"disclaimer",
			"archive",
			"feedback"
		],
		"hideButtonsOnSystem": [
			"addToReport",
			"delFromReport",
			"printVersion",
			"pdf",
			"share"
		],
		"hideButtonsOnMainPage": [
			"addToReport",
			"delFromReport",
			"printVersion",
			"pdf"
		],
		"hideCurrentButtonOnPage": true,
		"showTour": true,
		"sorting": {
			"ru": [
				"myReport",
				"addToReport",
				"delFromReport",
				"pdf",
				"printVersion",
				"share",
				"download",
				"history",
				"analysis",
				"feedback",
				"compare",
				"offline",
				"questionary",
				"social",
				"ios",
				"android",
				"mobileApp",
				"companyOnMap",
				"siteMap",
				"contacts",
				"xls",
				"glossary",
				"disclaimer",
				"archive"
			],
			"en": [
				"myReport",
				"addToReport",
				"delFromReport",
				"pdf",
				"printVersion",
				"share",
				"download",
				"history",
				"analysis",
				"feedback",
				"compare",
				"offline",
				"questionary",
				"social",
				"ios",
				"android",
				"mobileApp",
				"companyOnMap",
				"siteMap",
				"contacts",
				"xls",
				"glossary",
				"disclaimer",
				"archive"
			]
		},
		"links": [
			{
				"id": "myReport",
				"modifier": "myreport",
				"targetBlank": false,
				"url": "${rootUrl}/my-report",
				"text": {
					"ru": "Мой отчет",
					"en": "My report"
				}
			},
			{
				"id": "addToReport",
				"modifier": "add js-add-page js-no-collapse",
				"targetBlank": false,
				"url": "javascript:;",
				"text": {
					"ru": "Добавить в&nbsp;«Мой&nbsp;отчет»",
					"en": "Add to&nbsp;My&nbsp;Report"
				}
			},
			{
				"id": "delFromReport",
				"modifier": "del js-del-page js-no-collapse",
				"targetBlank": false,
				"url": "javascript:;",
				"text": {
					"ru": "Удалить из «Моего отчета»",
					"en": "Delete from My Report"
				}
			},
			{
				"id": "printVersion",
				"modifier": "print js-print",
				"targetBlank": true,
				"url": "javascript:;",
				"text": {
					"ru": "Печать страницы",
					"en": "Print version"
				},
				"event": "window.print();"
			},
			{
				"id": "pdf",
				"modifier": "pdf js-get-pdf",
				"targetBlank": true,
				"url": "${pdf}",
				"text": {
					"ru": "Скачать в PDF",
					"en": "PDF version"
				}
			},
			{
				"id": "share",
				"modifier": "share js-share",
				"targetBlank": false,
				"url": "javascript:;",
				"text": {
					"ru": "Поделиться",
					"en": "Share"
				},
				"subList": [
					{
						"id": "shareEmail",
						"modifier": "email js-share-form-button",
						"targetBlank": false,
						"url": "",
						"text": {
							"ru": "E-mail",
							"en": "E-mail"
						}
					},
					{
						"id": "shareFacebook",
						"modifier": "facebook",
						"targetBlank": true,
						"url": "https://www.facebook.com/sharer/sharer.php?u={{pageUrl}}&t={{pageTitle}}",
						"text": {
							"ru": "Facebook",
							"en": "Facebook"
						}
					},
					{
						"id": "shareTwitter",
						"modifier": "twitter",
						"targetBlank": true,
						"url": "http://twitter.com/share?text={{pageTitle}}&url={{pageUrl}}",
						"text": {
							"ru": "Twitter",
							"en": "Twitter"
						}
					},
					{
						"id": "shareVkontakte",
						"modifier": "vkontakte",
						"targetBlank": true,
						"url": "http://vkontakte.ru/share.php?url={{pageUrl}}&title={{pageTitle}}&image={{thisSiteUrl}}&description=",
						"text": {
							"ru": "Вконтакте",
							"en": "Vkontakte"
						}
					}
				]
			},
			{
				"id": "history",
				"modifier": "history",
				"targetBlank": false,
				"url": "${rootUrl}/history",
				"text": {
					"ru": "История",
					"en": "History"
				}
			},
			{
				"id": "feedback",
				"modifier": "feedback js-feedback-form-button",
				"targetBlank": false,
				"url": "javascript:;",
				"text": {
					"ru": "Обратная связь",
					"en": "Feedback"
				}
			},
			{
				"id": "download",
				"modifier": "download",
				"targetBlank": false,
				"url": "${rootUrl}/downloads",
				"text": {
					"ru": "Центр загрузки",
					"en": "Download center"
				}
			},
			{
				"id": "analysis",
				"modifier": "analysis",
				"targetBlank": false,
				"url": "${rootUrl}/interactive-analysis",
				"text": {
					"ru": "Интерактивный анализ",
					"en": "Interactive analysis"
				}
			},
			{
				"id": "compare",
				"modifier": "compare",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": {
						"compare": "Сравнить с ",
						"see": "Смотреть ",
						"yearText": "2015 г.",
						"compareList": "Сравнить с предыдущими отчетами",
						"seeList": "Смотреть предыдущие отчеты",
						"previousReports": "Предыдущие отчеты"
					},
					"en": {
						"compare": "Compare with ",
						"see": "See ",
						"yearText": "2015 y.",
						"compareList": "Compare with previous reports",
						"seeList": "See previous reports",
						"previousReports": "Previous reports"
					}
				}
			},
			{
				"id": "offline",
				"modifier": "offline",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Off-line версия",
					"en": "Off-line version"
				}
			},
			{
				"id": "questionary",
				"modifier": "questionary",
				"targetBlank": false,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Анкета",
					"en": "Quetionnaire"
				}
			},
			{
				"id": "social",
				"modifier": "social js-social js-no-collapse",
				"targetBlank": false,
				"url": "javascript:;",
				"text": {
					"ru": "Компания в соц. сетях",
					"en": "The company in social"
				},
				"subList": [
					{
						"id": "socialVkontakte",
						"modifier": "vkontakte",
						"targetBlank": true,
						"url": "http://vkontakte.ru",
						"text": {
							"ru": "Вконтакте",
							"en": "Vkontakte"
						}
					},
					{
						"id": "socialTwitter",
						"modifier": "twitter",
						"targetBlank": true,
						"url": "http://twitter.com",
						"text": {
							"ru": "Twitter",
							"en": "Twitter"
						}
					},
					{
						"id": "socialFacebook",
						"modifier": "facebook",
						"targetBlank": true,
						"url": "https://www.facebook.com",
						"text": {
							"ru": "Facebook",
							"en": "Facebook"
						}
					},
					{
						"id": "socialInstagram",
						"modifier": "instagram",
						"targetBlank": true,
						"url": "https://instagram.com",
						"text": {
							"ru": "Instagram",
							"en": "Instagram"
						}
					},
					{
						"id": "socialYoutube",
						"modifier": "youtube",
						"targetBlank": true,
						"url": "https://youtube.com",
						"text": {
							"ru": "YouTube",
							"en": "YouTube"
						}
					}
				]
			},
			{
				"id": "ios",
				"modifier": "ios",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Приложение для iOS",
					"en": "iOS app"
				}
			},
			{
				"id": "android",
				"modifier": "android",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Приложение для Android",
					"en": "Android app"
				}
			},
			{
				"id": "mobileApp",
				"modifier": "mobile-app",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Приложение для iOS и Android",
					"en": "Android and iOS apps"
				}
			},
			{
				"id": "companyOnMap",
				"modifier": "on-map",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Компания на карте",
					"en": "Company on the map"
				}
			},
			{
				"id": "siteMap",
				"modifier": "site-map",
				"targetBlank": true,
				"url": "${rootUrl}/sitemap",
				"text": {
					"ru": "Карта сайта",
					"en": "Sitemap"
				}
			},
			{
				"id": "contacts",
				"modifier": "contacts",
				"targetBlank": false,
				"url": "${rootUrl}/contacts/",
				"text": {
					"ru": "Контакты",
					"en": "Contacts"
				}
			},
			{
				"id": "xls",
				"modifier": "xls",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "xls",
					"en": "xls"
				}
			},
			{
				"id": "glossary",
				"modifier": "glossary",
				"targetBlank": false,
				"url": "${rootUrl}/glossary/",
				"text": {
					"ru": "Глоссарий",
					"en": "Glossary"
				}
			},
			{
				"id": "archive",
				"modifier": "archive-reports",
				"targetBlank": false,
				"url": "${rootUrl}/archive/",
				"text": {
					"ru": "Предыдущие отчеты",
					"en": "Previous reports"
				}
			},
			{
				"id": "disclaimer",
				"modifier": "disclaimer",
				"targetBlank": false,
				"url": "${rootUrl}/disclaimer/",
				"text": {
					"ru": "Ограничение ответственности",
					"en": "Disclaimer"
				}
			}
		]
	},
	"materials": {
		"title": {
			"ru": "Материалы",
			"en": "Materials"
		},
		"slideType": "vertical",
		"buttonWithText": false,
		"offlineHideButtons": [
			"offline"
		],
		"buttonsPanelHideButtons": [],
		"sorting": {
			"ru": [
				"ar",
				"ar2",
				"sustainability",
				"fr",
				"app",
				"journal",
				"offline"
			],
			"en": [
				"ar",
				"ar2",
				"sustainability",
				"fr",
				"app",
				"journal",
				"offline"
			]
		},
		"links": [
			{
				"id": "ar",
				"modifier": "ar",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Годовой Отчет 2012",
					"en": "Annual Report 2012"
				}
			},
			{
				"id": "ar2",
				"modifier": "ar",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Годовой Отчет 2013",
					"en": "Annual Report 2013"
				}
			},
			{
				"id": "sustainability",
				"modifier": "sustainability",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Отчет об устройчивом развитии",
					"en": "Sustainability Report"
				}
			},
			{
				"id": "fr",
				"modifier": "fr",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Финансовый Отчет 2012",
					"en": "Financial Report 2012"
				}
			},
			{
				"id": "app",
				"modifier": "app",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Приложения",
					"en": "Applications"
				}
			},
			{
				"id": "journal",
				"modifier": "journal",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Корпоративный журнал",
					"en": "Corporate journal"
				}
			},
			{
				"id": "offline",
				"modifier": "offline",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Off-line версия",
					"en": "Off-line version"
				}
			}
		]
	},
	"download-pdf": {
		"title": {
			"ru": "Скачать PDF",
			"en": "Download PDF"
		},
		"slideType": "vertical",
		"buttonWithText": true,
		"offlineHideButtons": [],
		"buttonsPanelHideButtons": [],
		"sorting": {
			"ru": [
				"pdfPages",
				"pdfSpreads"
			],
			"en": [
				"pdfPages",
				"pdfSpreads"
			]
		},
		"links": [
			{
				"id": "pdfPages",
				"modifier": "pdf-pages",
				"targetBlank": true,
				"url": "/pdf/${site}/${lang}/${lang}_annual_report_pages.pdf",
				"text": {
					"ru": "Постранично",
					"en": "Page by page"
				}
			},
			{
				"id": "pdfSpreads",
				"modifier": "pdf-spreads",
				"targetBlank": true,
				"url": "/pdf/${site}/${lang}/${lang}_annual_report_spreads.pdf",
				"text": {
					"ru": "Разворотами",
					"en": "Spreads"
				}
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/buttons-panel/compact-in-column/config.yaml
// module id = 100
// module chunks = 0